import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#FAFAF8] border-t border-[#E8E1DA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <img
              src="/brand/face-it-logo.jpg"
              alt="Face It Aesthetics by Nurse Dimi"
              className="w-40 sm:w-48 h-40 sm:h-48 rounded-2xl object-cover"
            />
            <p className="mt-6 text-sm text-[#5C534B] max-w-md leading-relaxed">
              A private cosmetic studio in Belmore, NSW — offering considered,
              clinically led aesthetic treatments by Nurse Dimi, a fully trained
              Cosmetic Registered Nurse.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="overline">Explore</p>
            <ul className="mt-5 space-y-3 text-sm text-[#2C2723]">
              <li><a href="#about" className="hover:text-[#8C6A53]">About</a></li>
              <li><a href="#services" className="hover:text-[#8C6A53]">Treatments</a></li>
              <li><a href="#gallery" className="hover:text-[#8C6A53]">Gallery</a></li>
              <li><a href="#contact" className="hover:text-[#8C6A53]">Contact</a></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="overline">Connect</p>
            <ul className="mt-5 space-y-3 text-sm text-[#2C2723]">
              <li>312 Burwood Road, Belmore, NSW 2192</li>
              <li>
                <a href="tel:+61413431729" className="hover:text-[#8C6A53]">
                  0413 431 729
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@faceitaesthetics.com.au"
                  className="hover:text-[#8C6A53] break-all"
                >
                  info@faceitaesthetics.com.au
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/face_itaesthetics"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-2 hover:text-[#8C6A53]"
                >
                  <Instagram size={14} /> @face_itaesthetics
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#E8E1DA] grid md:grid-cols-2 gap-6 items-start">
          <p
            className="text-[11px] leading-relaxed text-[#5C534B] max-w-2xl"
            data-testid="tga-disclaimer"
          >
            <strong className="text-[#2C2723]">TGA Compliance Notice.</strong>{" "}
            Cosmetic injectable treatments are Schedule 4 (Prescription Only)
            medicines and require consultation with a qualified medical
            professional. This website does not provide medical advice and does
            not advertise prescription-only products. Individual results vary.
            All procedures carry potential risks which will be discussed during
            your in-person consultation. Treatments are only provided to suitable
            candidates aged 18 and over following an in-person assessment.
          </p>
          <p className="text-[11px] text-[#5C534B] md:text-right">
            © {new Date().getFullYear()} Face It Aesthetics · All rights
            reserved.
            <br />
            Designed with care · Belmore, NSW
          </p>
        </div>
      </div>
    </footer>
  );
}
